import {createContext, useContext, useEffect, useReducer} from "react";
import {initialState, reducer, setDetail} from "./reducer";
import {useOrderReserveGet} from "../../../../api/orderReserve";
import {useQueryParam} from "../../../../hooks";
import {useTranslation} from "react-i18next";

const Context = createContext(initialState);

function BookingOrderDetailController() {
  const { state, dispatch } = useBookingOrderDetailContext();
  const { loading, getDetail } = useOrderReserveGet();
  const [orderId] = useQueryParam('orderId');
  const { t } = useTranslation();
  
  /**
   * 获取预约订单详情
   * @returns {Promise<void>}
   */
  const getBookingDetail = async () => {
    let { data } = await getDetail({ orderId });
    if (data) {
      dispatch(setDetail(data));
    }
  };
  
  /**
   * 获取预约订单状态字段
   * @param status
   * @returns {string}
   */
  const getStatus = (status) => {
    switch (status) {
      case '0':
        return '待审核';
      case '1':
        return '通过';
      case '2':
        return '不通过';
      case '3':
        return '已取消';
      case '4':
        return '已完成';
      default:
        return '未知状态';
    }
    return '全部'; // status === false
  };

  /**
   * 地址转换
   */
  const transformAddress = (str) => {
    if(typeof str !== "string" || !str) return
    const areaStrArr = str.split(",")
    return `${t(areaStrArr[0])}${t(areaStrArr[1])}${t(areaStrArr[2])}`
  }
  
  return {
    loading,
    getBookingDetail,
    getStatus,
    transformAddress
  };
  
}

function useBookingOrderDetailContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useBookingOrderDetailContext, BookingOrderDetailController};

export default function BookingOrderDetailContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
